import { Suspense } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";
import RootUserLayout from "../layout";
import { EcosuiteErrorBoundary } from "@/components/error-boundary";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { superusersQueryOptions } from "../service/user";
import { SuperusersTable } from "./components/superusers-table";

function SuperusersContent() {
  const { data: superusers } = useSuspenseQuery(superusersQueryOptions);

  return <SuperusersTable superusers={superusers} />;
}

export default function Superusers() {
  return (
    <RootUserLayout
      pageTitle="Superusers"
      pageDescription="List of ecosuite superusers"
    >
      <Suspense
        fallback={
          <LoadingScreen
            text="Loading Superusers..."
            className="h-[calc(100vh-180px)]"
          />
        }
      >
        <EcosuiteErrorBoundary>
          <SuperusersContent />
        </EcosuiteErrorBoundary>
      </Suspense>
    </RootUserLayout>
  );
}
